import { Link, Navigate, Outlet, useNavigate } from 'react-router';
import { ThemeToggle } from '../components/ThemeToggle';
import { useOperator } from './operatorApi';
import { useOperatorTitle } from './useOperatorTitle';
import './operator.css';

/** Rahmen der Betreiberoberfläche: eigene Kopfleiste, keine Seitenleiste der Mandanten. Ohne Betreiber-Sitzung geht es zur Anmeldung. */
export function OperatorLayout() {
  useOperatorTitle();
  const { session, loading, logout } = useOperator();
  const navigate = useNavigate();
  if (loading) return <div className="center-screen">Wird geladen …</div>;
  if (!session) return <Navigate to="/betreiber/anmelden" replace />;

  return (
    <div className="operator">
      <header className="topbar operator__bar">
        <Link to="/betreiber" className="brand">
          <img className="brand__mark" src="/brand/wirkia-symbol.webp" alt="" width="60" height="26" />
          <span>
            Wirkia <small>Betreiber</small>
          </span>
        </Link>
        <nav className="operator__nav" aria-label="Betreiber">
          <Link to="/betreiber">Mandanten</Link>
          <Link to="/betreiber/pakete">Pakete</Link>
          <Link to="/betreiber/branchen">Branchen</Link>
          <Link to="/betreiber/zahlungen">Zahlungen</Link>
          <Link to="/betreiber/mailvorlagen">Mailvorlagen</Link>
        </nav>
        <div className="operator__user">
          <ThemeToggle variant="icon" />
          <span className="operator__name">{session.operator.name}</span>
          <button
            type="button"
            className="btn btn--ghost-inverse btn--sm"
            onClick={async () => {
              await logout();
              navigate('/betreiber/anmelden', { replace: true });
            }}
          >
            Abmelden
          </button>
        </div>
      </header>
      <main className="content operator__content">
        <Outlet />
      </main>
    </div>
  );
}
